import { VE_PAGE_CHANGE } from './custom-events';

const MAX_VISIBLE_BUTTONS = 5

export default (type, initialTotalPages, identifier, perPage, perPageDesktop, totalItemsCount) => ({
    currentPage: 1,
    totalPages: initialTotalPages,
    identifier: identifier,
    perPage: perPage,
    perPageDesktop: perPageDesktop,
    totalItemsCount: totalItemsCount,
    loop: false,
    visiblePages: [],

    goTo(page) {
        page = Math.max(1, Math.min(page, this.totalPages));
        this.currentPage = page;
        this.$dispatch(VE_PAGE_CHANGE, { page: this.currentPage, identifier: this.identifier });
        this.$nextTick(() => {
            this.updateVisiblePages();
        });
    },

    updateVisiblePages() {
        const maxVisibleButtons = type === 'dots' ? this.totalPages : MAX_VISIBLE_BUTTONS;
        const halfVisible = Math.floor(maxVisibleButtons / 2);
        this.visiblePages = [];

        if (this.totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= this.totalPages; i++) {
                this.visiblePages.push(i);
            }
        } else {
            if (this.currentPage <= halfVisible + 1) {
                for (let i = 1; i <= maxVisibleButtons; i++) {
                    this.visiblePages.push(i);
                }
            } else if (this.currentPage >= this.totalPages - halfVisible) {
                for (let i = this.totalPages - maxVisibleButtons + 1; i <= this.totalPages; i++) {
                    this.visiblePages.push(i);
                }
            } else {
                for (let i = this.currentPage - halfVisible; i <= this.currentPage + halfVisible; i++) {
                    this.visiblePages.push(i);
                }
            }
        }
    },

    init() {
        window.addEventListener(VE_PAGE_CHANGE, (event) => {
            if (event.target !== this.$el && event.detail.identifier === this.identifier) {
                this.currentPage = event.detail.page;
                this.$nextTick(() => {
                    this.updateVisiblePages();
                });
            }
        });

        this.adjustTotalPages();
        window.addEventListener('resize', this.adjustTotalPages.bind(this));
    },

    adjustTotalPages() {
        if (window.innerWidth >= 1024) {
            this.totalPages = Math.ceil(this.totalItemsCount / this.perPageDesktop);
        } else {
            this.totalPages = Math.ceil(this.totalItemsCount / this.perPage);
        }
        this.$nextTick(() => {
            this.updateVisiblePages();
        });
    }
});
